export const updateSettingSchema = {
  type: "object",
  properties: {
    minIosVersion: { type: "string" },
    minAndroidVersion: { type: "string" },
    forceExpoUpdatesIos: { type: "boolean" },
    forceExpoUpdatesAndroid: { type: "boolean" },
    useNewTicketSystem: { type: "boolean" },
    useNewMobileApp: { type: "boolean" },
    enableSetupScreen: { type: "boolean" },
    iosAppStoreUrl: { type: "string" },
    androidAppStoreUrl: { type: "string" },
  },
};

export const getSettingSchema = {
  params: {
    type: "object",
    properties: {
      key: {
        type: "string",
        enum: [
          "minIosVersion",
          "minAndroidVersion",
          "forceExpoUpdatesIos",
          "forceExpoUpdatesAndroid",
          "useNewTicketSystem",
          "useNewMobileApp",
          "enableSetupScreen",
          "iosAppStoreUrl",
          "androidAppStoreUrl",
        ],
      },
    },
    required: ["key"],
  },
};

const semverRegex =
  "^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(?:-((?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)))*(?:\\+([0-9a-zA-Z-]+(?:\\.[0-9a-zA-Z-]+)*))?$";

export const web_systemSettingsSchema = {
  type: "object",
  properties: {
    minIosVersion: {
      type: "string",
      minLength: 1,
      pattern: semverRegex,
    },
    minAndroidVersion: {
      type: "string",
      minLength: 1,
      pattern: semverRegex,
    },
    forceExpoUpdatesIos: { type: "boolean" },
    forceExpoUpdatesAndroid: { type: "boolean" },
    useNewTicketSystem: { type: "boolean" },
    useNewMobileApp: { type: "boolean" },
    enableSetupScreen: { type: "boolean" },
    iosAppStoreUrl: {
      type: "string",
      minLength: 1,
      pattern: "^(https?://.+)$",
      errorMessage: {
        pattern: "Please enter a valid URL starting with http:// or https://",
      },
    },
    androidAppStoreUrl: {
      type: "string",
      minLength: 1,
      pattern: "^(https?://.+)$",
      errorMessage: {
        pattern: "Please enter a valid URL starting with http:// or https://",
      },
    },
  },
  required: [
    "minIosVersion",
    "minAndroidVersion",
    "forceExpoUpdatesIos",
    "forceExpoUpdatesAndroid",
    "useNewTicketSystem",
    "useNewMobileApp",
    "enableSetupScreen",
    "iosAppStoreUrl",
    "androidAppStoreUrl",
  ],
};
